import Vue from 'vue-ltur';
import VueCustomElement from 'vue-custom-element';
import HotelRatingContainer from 'Rating/hotel-rating-container.vue';
var initializeHotelRatingContainer = function () {
    Vue.use(VueCustomElement);
    // @ts-ignore
    Vue.customElement('c-hotel-rating-container', (new HotelRatingContainer().$options));
};
export default initializeHotelRatingContainer;
